import { useContext, useMemo } from 'react'
import { LanguageContext } from '../../i18n'
import {
  buildBusinessSeatBuckets,
  buildPricingPlanCards,
  getPricingCopy,
  type PricingCopyLabels,
} from '../helpers/pricingI18n.helper'
import type { BusinessSeatBucket, PricingPlanCard } from '../constants/pricingPlans.constants'

export interface UsePricingI18nReturn {
  planCards: PricingPlanCard[]
  copy: PricingCopyLabels
  seatBuckets: readonly BusinessSeatBucket[]
}

export function usePricingI18n(): UsePricingI18nReturn {
  const languageContext = useContext(LanguageContext)
  if (!languageContext) {
    throw new Error('usePricingI18n must be used within LanguageProvider')
  }
  const { t } = languageContext

  return useMemo(
    () => ({
      planCards: buildPricingPlanCards(t),
      copy: getPricingCopy(t),
      seatBuckets: buildBusinessSeatBuckets(t),
    }),
    [t],
  )
}
